export default "__VITE_ASSET__ByogsNq9__"